// Hide/show cart button based on scroll position
document.addEventListener('DOMContentLoaded', function() {
  const cartButton = document.querySelector('.cart-link');
  const cartDrawerToggle = document.querySelector('[data-cart-drawer-toggle]');
  const heroSection = document.querySelector('.hero-products');
  
  // Function to hide cart elements
  function hideCartElements() {
    if (cartButton) cartButton.style.opacity = '0';
    if (cartButton) cartButton.style.pointerEvents = 'none';
    if (cartDrawerToggle) cartDrawerToggle.style.opacity = '0';
    if (cartDrawerToggle) cartDrawerToggle.style.pointerEvents = 'none';
  }
  
  // Function to show cart elements
  function showCartElements() {
    if (cartButton) cartButton.style.opacity = '1';
    if (cartButton) cartButton.style.pointerEvents = 'auto';
    if (cartDrawerToggle) cartDrawerToggle.style.opacity = '1';
    if (cartDrawerToggle) cartDrawerToggle.style.pointerEvents = 'auto';
  }
  
  // Add transition for smooth animation
  if (cartButton) cartButton.style.transition = 'opacity 0.3s ease';
  if (cartDrawerToggle) cartDrawerToggle.style.transition = 'opacity 0.3s ease';
  
  // Check scroll position
  function checkScroll() {
    if (heroSection) {
      const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
      const scrollPosition = window.scrollY + 100; // Account for header height
      
      if (scrollPosition < heroBottom) {
        hideCartElements();
      } else {
        showCartElements();
      }
    } else {
      // If no hero section, always show cart
      showCartElements();
    }
  }
  
  // Initial check
  checkScroll();
  
  // Check on scroll
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(checkScroll, 10);
  });
  
  // Check on resize
  window.addEventListener('resize', checkScroll);
});